// extracted by css-extract-rspack-plugin
export default {"container":"container--ayoMfjtQOg6uF7XF"};